<template>
  <div class="tool-modal-ead">
    <hr />
    <bp-select
      v-model="form.product_id"
      id="product-select"
      label="Nome do produto"
      placeholder="Selecionar produto"
      :disabled="isEdit"
      class="mb-3"
      :errors="errors.product_id"
      :options="products.map(({ id, name }) => ({ id, name }))"
      required
    />
    <div class="row">
      <div class="col-lg-6">
        <bp-input
          v-model="form.description"
          id="description"
          class="mb-3"
          label="Descrição da integração (Opcional)"
          placeholder="Digite a descrição da integração"
          :errors="errors.description"
        />
      </div>
      <div class="col-lg-6">
        <bp-input
          v-model="form.url"
          id="url"
          class="mb-3"
          label="URL"
          placeholder="Digite a URL"
          :errors="errors.url"
          required
        />
      </div>
      <div class="col-lg-6">
        <bp-input
          v-model="form.token"
          id="token"
          label="Token"
          placeholder="Digite o token da integração"
          :errors="errors.token"
          required
        />
      </div>
      <div class="col-lg-6">
        <bp-input
          v-model="form.course"
          type="number"
          id="course-id"
          label="ID do curso"
          placeholder="Digite o id"
          :errors="errors.course"
          required
        />
      </div>
    </div>

    <div class="submit-buttons">
      <bp-button
        color="neutral"
        variant="filled-1"
        label="Cancelar"
        @click="$emit('close')"
      />
      <bp-button
        label="Integrar"
        :loading="loading"
        :disabled="!isValid"
        @click="submit"
      />
    </div>
  </div>
</template>
<script>
import { formFields } from "@/functions/helpers";
import IntegrationModalMixin from "@/mixins/integrationModal";
export default {
  mixins: [IntegrationModalMixin],
  data() {
    return {
      ...formFields(
        ["product_id", "url", "status", "token", "course", "description"],
        {
          ...this.integrationToEdit,
          course: this.integrationToEdit?.extras?.course
        }
      )
    };
  },
  computed: {
    isValid() {
      return (
        this.form.product_id &&
        this.form.course &&
        this.form.token &&
        this.form.url
      );
    }
  }
};
</script>
